export const UPDATE_WORK_STATUS_WS = 'UPDATE_WORK_STATUS_WS';
export const UPDATE_WORK_STATUS_WS_SUCCESS = 'UPDATE_WORK_STATUS_WS_SUCCESS';
export const UPDATE_WORK_STATUS_WS_ERROR = 'UPDATE_WORK_STATUS_WS_ERROR';
